import { render, staticRenderFns } from "./testHBCA.vue?vue&type=template&id=29087944"
import script from "./testHBCA.vue?vue&type=script&lang=js"
export * from "./testHBCA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports